import { ErrorType } from "./ChatGPCTypes";

export enum ERRORS {
  SESSION_EXPIRED = "We're sorry, your session has expired. Please log in again.",
  UNEXPECTED = "We're sorry, an unexpected error occurred while retrieving your answer. Please try resubmitting your question. If you keep getting this message, please contact us at chatgpc_support@genpt.com.",
  ABORTED = "The response generation has been stopped. You can enter a new question or resubmit a previous one to continue.",
  TOO_MANY_TOKENS = "We're sorry, but your message is too long. Please shorten it and try again.",
  TRAINING_REQUIRED = "You must first complete the required Workday training for access.\n\n ChatGPC access may take up to the next business day after successful training completion.",
  CHAT_INITIALIZATION_FAILED = "We're sorry, there was a problem setting up your conversation. Please try resubmitting your question.",
}

export type HttpErrorType = {
  message: string;
  status: number;
  name: string;
};

export type ErrorInfo = {
  error: ERRORS;
  errorType: ErrorType;
};
